// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"785":"c15f281e","807":"cea79e08"}[chunkId] + ".css";
};